import { connect } from 'react-redux';
import { withTranslation } from '@piwikpro/ui-components';
import MaxSessionEventCount from './MaxSessionEventCount';

const mapStateToProps = (state: any) => ({
  globalTrackerSettings: state.trackerSettings.global.settings,
  appTrackerSettings: state.trackerSettings.app.settings,
});

export default withTranslation(['administration'])(connect(mapStateToProps, null)(MaxSessionEventCount));
